<template>
  <v-btn block depressed :color="tour.status">{{ tour.weight }}/{{ tour.maxWeight }}</v-btn>
</template>

<script>
export default {
  name: 'TourWorkload',
  props: ['tour']
}
</script>



// WEBPACK FOOTER //
// src/components/TourWorkload.vue